/**************************************************
 * Nombre:       Seccion_Colecciones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Categorias from "./Componentes/Home_Categorias";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {where} from "firebase/firestore";
import {SECCIONES} from "../../Constantes";
import {irArriba} from "../../Utilidades/irArriba";
import Home_Colecciones from "./Componentes/Home_Colecciones";
import Home_Suscripcion from "./Componentes/Home_Suscripcion";


const Seccion_Colecciones = () => {
    const {sCell} = useResponsive()
    const [colecciones, setColecciones] = useState([])

    useEffect(() => {
        irArriba()
        let w = [where('estado', '==', 'Publicada')]

        obtenerColWheres({col: 'colecciones', wheres: w}).then((dox) => {
            setColecciones(dox.data)
        })
    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 8}}>
                <Home_Colecciones dir={'center'}/>
            </Grid>

            <Grid id={SECCIONES[0]} container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 12, mb: 12}}>
                <Home_Categorias/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8, mb: 12}}>
                <Home_Suscripcion/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Colecciones